export enum ComponentUsage {
  SUMMARY = 'SUMMARY',
  REVIEW = 'REVIEW',
}
